import axios from "axios";
import {BODEGA, NOMBREPEDIDO} from "../Constantes";
import {obtenerPesoTotal} from "./obtenerPesoTotal";
import {obtenerDimenciones} from "./obtenerDimenciones";
import {obtenerValorTotal} from "./obtenerValorTotal";
import {obtenerCodigoDane} from "./obtenerCodigoDane";

export const generarGuia = async ({pedido}) => {

    let pesoTotal = obtenerPesoTotal(pedido.productos)
    let dimenciones = obtenerDimenciones(pedido.productos)
    let valorTotal = obtenerValorTotal(pedido.productos)
    let codigoDane = obtenerCodigoDane(pedido)

    let data = JSON.stringify(
        {
            "idRate": pedido.idEnvio,
            "myShipmentReference": `Pedido ${pedido.consecutivo}`,
            "external_order_id": pedido.id,
            "requestPickup": false,
            "pickupDate": "2027-11-24",
            "insurance": true,
            "description": NOMBREPEDIDO,
            "contentValue": valorTotal,
            "codValue": valorTotal > 1800000 ? 1700000 : valorTotal,
            "includeGuideCost": false,
            "codPaymentMethod": "cash",
            "packages": [
                {
                    "weight": pesoTotal,
                    "height": dimenciones.alto,
                    "width": dimenciones.largo,
                    "length": dimenciones.fondo
                }
            ],
            "origin": {
                "company": BODEGA.empresa,
                "firstName": BODEGA.nombre,
                "lastName": BODEGA.apellido,
                "email": BODEGA.correo,
                "phone": BODEGA.celular,
                "address": BODEGA.direccion,
                "suburb": BODEGA.adicional,
                "crossStreet": BODEGA.calle,
                "reference": BODEGA.referencia,
                "daneCode": BODEGA.codigo
            },
            "destination": {
                "company": "N/A",
                "firstName": validarDato(pedido.nombres, 14),
                "lastName": validarDato(pedido.apellidos, 14),
                "email": validarDato(pedido.correo, 60),
                "phone": validarDato(validarTelefono(pedido.celular), 10),
                "address": validarDato(pedido.direccion, 50),
                "suburb": validarDato(pedido.barrio, 30),
                "crossStreet": 'N/A',
                "reference": validarDato(pedido.indicaciones, 25),
                "daneCode": codigoDane + '000'
            }
        }
    );


    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        //  url: 'https://api.envioclickpro.com.co/api/v2/shipment_sandbox', //test
        url: 'https://api.envioclickpro.com.co/api/v2/shipment',
        headers: {
            'Authorization': 'd579cb35-81f8-4590-8d71-19cb90221223',
            'Content-Type': 'application/json',
        },
        data: data
    };


    return new Promise((resolve) => {
        // console.log(data)

        axios(config)
            .then(function (response) {
                //console.log(response)
                if (response.status === 200) {
                    return resolve({res: true, data: response.data.data})
                } else {
                    return resolve({res: false, data: "error interno"})
                }
            })
            .catch(function (error) {
                //  console.log(error)
                return resolve({res: false, data: error.response.data.error, dataError: error.response})
            });

    })
}

const validarDato = (dato, max) => {

    if (!dato) {
        return 'N/A'
    }

    if (dato.length < max) {
        return dato
    }

    return dato.substr(0, max)


}

const validarTelefono = (cel) => {

    let num = cel.replaceAll(' ', '')
    num = num.replaceAll('-', '')
    return num

}